<script>
    import Header from '~/components/Header.svelte';
    import Footer from '~/components/Footer.svelte';

    import Posts from '~/components/Posts.svelte';

    import About from '~/pages/About.svelte';
    import Admin from '~/pages/Admin.svelte';
    import Ask from '~/pages/Ask.svelte';
    import Auth from '~/pages/Auth.svelte';
    import Blog from '~/pages/Blog.svelte';
    import Post from '~/pages/Post.svelte';
    import Tags from '~/pages/Tags.svelte';
    import NotFound from '~/pages/NotFound.svelte';

    import { Router, Route } from 'svelte-routing';
    import { slide } from 'svelte/transition';

    import categories from '~/categories';
</script>

<style lang="scss">
    .page {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
    }

    .top {
        flex: 1 0 auto;
    }
</style>

<Router>
    <div class="page">
        <section class="top">
            <Header/>
            <main id="main" class="wrapper">
                <Route path="post/:id" component={Post} />
                <Route path="about" component={About} />
                <Route path="ask" component={Ask} />
                {#each categories as category}
                    <Route path={category.name} title={category.text} component={Posts} category={category.name} />
                {/each}
                <Route path="tags/:tagString" component={Tags} />
                <Route path="admin" component={Admin} />
                <Route path="auth" component={Auth} />
                <Route path="/" component={Blog} />
                <Route path="" component={NotFound}/> 
            </main>
        </section>
        <Footer/>
    </div>
</Router>
